import React from 'react';
import {
    Box,
    Text,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    useColorModeValue,
    Stat,
    StatLabel,
    StatNumber,
    SimpleGrid,
} from '@chakra-ui/react';

const OperationDetail = ({ data }) => {
    const bg = useColorModeValue('gray.50', 'gray.700');
    const redColor = useColorModeValue('red.500', 'red.300');
    const greenColor = useColorModeValue('green.500', 'green.300');

    return (
        <Box w="full" bg={bg} p={4}>
            {/* Header Section - Horizontal and Responsive */}
            <Box mb={4}>
                <Text fontSize="2xl" fontWeight="bold" mb={4} color={data.added > 0 || data.missing > 0 ? redColor : undefined}>
                    {data.operationDetails.order}
                </Text>
                <SimpleGrid columns={[1, 2, 3]} spacing={4} mb={4}>
                    <Box>
                        <Text fontWeight="bold">Operador:</Text>
                        <Text>{data.operationDetails.operator.userName}</Text>
                    </Box>
                    <Box>
                        <Text fontWeight="bold">Correo:</Text>
                        <Text>{data.operationDetails.operator.userEmail}</Text>
                    </Box>
                    <Box>
                        <Text fontWeight="bold">Ubicación:</Text>
                        <Text>{data.operationDetails.location}</Text>
                    </Box>
                    <Box>
                        <Text fontWeight="bold">Operación:</Text>
                        <Text>{data.operationDetails.operation}</Text>
                    </Box>
                    <Box>
                        <Text fontWeight="bold">Esperado:</Text>
                        <Text>{data.operationDetails.espected}</Text>
                    </Box>
                    <Box>
                        <Text fontWeight="bold">Inicio:</Text>
                        <Text>{new Date(data.operationDetails.startTime).toLocaleString()}</Text>
                    </Box>
                    <Box>
                        <Text fontWeight="bold">Fin:</Text>
                        <Text>{new Date(data.operationDetails.endTime).toLocaleString()}</Text>
                    </Box>
                </SimpleGrid>
            </Box>

            {/* Stats Section */}
            <SimpleGrid columns={[2, null, 4]} spacing={4} mb={4}>
                <Stat>
                    <StatLabel>Encontrado</StatLabel>
                    <StatNumber color={greenColor}>{data.found}</StatNumber>
                </Stat>
                <Stat>
                    <StatLabel>Agregado</StatLabel>
                    <StatNumber color={data.added > 0 ? redColor : undefined}>{data.added}</StatNumber>
                </Stat>
                <Stat>
                    <StatLabel>Faltante</StatLabel>
                    <StatNumber color={data.missing > 0 ? redColor : undefined}>{data.missing}</StatNumber>
                </Stat>
                <Stat>
                    <StatLabel>Total</StatLabel>
                    <StatNumber>{data.total}</StatNumber>
                </Stat>
            </SimpleGrid>

            {/* Data Table Section */}
            <Box mb={4}>
                <Text fontSize="lg" fontWeight="bold" mb={2}>
                    Detalles de Operación
                </Text>
                <Table variant="simple">
                    <Thead>
                        <Tr>
                            <Th>No. Línea</Th>
                            <Th>No. Documento</Th>
                            <Th>No. Línea Pedido</Th>
                            <Th>No. Serie</Th>
                            <Th>Cantidad</Th>
                            <Th>No. Producto</Th>
                            <Th>Fecha y Hora</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {data.data.map((item, index) => (
                            <Tr key={index}>
                                <Td>{item.No_Linea}</Td>
                                <Td>{item.No_Documento}</Td>
                                <Td>{item.No_Linea_Pedido}</Td>
                                <Td>{item.No_Serie}</Td>
                                <Td>{item.Cantidad}</Td>
                                <Td>{item.sku}</Td>
                                <Td>{new Date(item.datetime).toLocaleString()}</Td>
                            </Tr>
                        ))}
                    </Tbody>
                </Table>
            </Box>

            {/* Customer Patch Section */}
            <Box>
                <Text fontSize="lg" fontWeight="bold" mb={2}>
                    Respuesta Servidor JHT
                </Text>
                <Table variant="simple">
                    <Thead>
                        <Tr>
                            <Th>No. Línea</Th>
                            <Th>No. Documento</Th>
                            <Th>No. Línea Pedido</Th>
                            <Th>Tipo Documento</Th>
                            <Th>No. Producto</Th>
                            <Th>Cantidad</Th>
                            <Th>No. Serie</Th>
                            <Th>Respuesta</Th> {/* New Respuesta Column */}
                        </Tr>
                    </Thead>
                    <Tbody>
                        {data.customerPatch.map((item, index) => (
                            <Tr key={index} bg={item.error ? redColor : undefined}>
                                <Td>{item.No_Linea}</Td>
                                <Td>{item.No_Documento}</Td>
                                <Td>{item.No_Linea_Pedido}</Td>
                                <Td>{item.Tipo_Documento}</Td>
                                <Td>{item.No_Producto}</Td>
                                <Td>{item.Cantidad}</Td>
                                <Td>{item.No_Serie}</Td>
                                <Td>{item.error ? item.error.message : 'Ok'}</Td> {/* Respuesta logic */}
                            </Tr>
                        ))}
                    </Tbody>
                </Table>
            </Box>
        </Box>
    );
};

export default OperationDetail;
